import DueDiligenceItemTypeSelectorContainer from './containers/DueDiligenceItemTypeSelectorContainer'

export default DueDiligenceItemTypeSelectorContainer
